// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2r3_T","contain-mode":"contain-mode-10XsB","containMode":"contain-mode-10XsB","content":"content-3Nh0N","title":"title-HUG0s","text":"text-22CG4"};